// ===============================
// FAVORITE SYSTEM (Stable Version)
// ===============================

function getFavorites() {
  return JSON.parse(localStorage.getItem("favorites")) || [];
}

function saveFavorites(data) {
  localStorage.setItem("favorites", JSON.stringify(data));
}

/* -------------------------------
   お気に入り一覧描画
-------------------------------- */
function renderFavorites() {
  const container = document.getElementById("favorite-list");
  if (!container) return;

  const favorites = getFavorites();
  container.innerHTML = "";

  if (favorites.length === 0) {
  container.innerHTML = `<p class="empty-favorite">${window.theme.favoriteEmptyText}</p>`;
  return;
}

  favorites.forEach(item => {
    container.insertAdjacentHTML(
      "beforeend",
      `
      <div class="favorite-item" data-id="${item.id}">
        <a href="${item.url}">
          <img src="${item.image}" alt="${item.title}">
          <span>${item.title}</span>
        </a>
        <button type="button" class="button button--simple favorite-remove" data-id="${item.id}">
          REMOVE
        </button>
      </div>
      `
    );
  });
}

/* -------------------------------
   商品ページボタン状態同期
-------------------------------- */
function syncFavoriteButtons() {
  const favorites = getFavorites();

  document.querySelectorAll(".favorite-button").forEach(btn => {
    const id = btn.dataset.productId;
    const exists = favorites.find(item => item.id === id);

    const svgIcon = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.68439 2.19621C7.81351 1.9346 8.18655 1.9346 8.31566 2.19621L9.98702 5.58275C10.0383 5.68664 10.1374 5.75864 10.252 5.7753L13.9893 6.31836C14.278 6.36031 14.3933 6.7151 14.1844 6.91873L11.4801 9.55479C11.3971 9.63565 11.3593 9.75216 11.3788 9.86634L12.0172 13.5885C12.0666 13.8761 11.7648 14.0953 11.5065 13.9596L8.16382 12.2022C8.06128 12.1483 7.93878 12.1483 7.83624 12.2022L4.49351 13.9596C4.23529 14.0953 3.93349 13.8761 3.98281 13.5885L4.62121 9.86634C4.64079 9.75216 4.60294 9.63565 4.51998 9.55479L1.81566 6.91873C1.60676 6.7151 1.72203 6.36031 2.01074 6.31836L5.74801 5.7753C5.86266 5.75864 5.96176 5.68664 6.01303 5.58275L7.68439 2.19621Z" stroke="#292929" stroke-width="1.1" stroke-linejoin="round"/>
</svg>

    `;

    if (exists) {
      btn.classList.add("is-active");
      btn.innerHTML = svgIcon + " " + window.theme.favoriteEmptyTextOk;
    } else {
      btn.classList.remove("is-active");
      btn.innerHTML = svgIcon + " " + window.theme.favoriteEmpty;
    }
  });
}

/* -------------------------------
   追加・削除クリック処理
-------------------------------- */
document.addEventListener("click", function (e) {

  /* ---------- 追加/切替 ---------- */
  const addBtn = e.target.closest(".favorite-button");
  if (addBtn) {
    e.preventDefault();
    e.stopPropagation();

    const id = addBtn.dataset.productId;
    const title = addBtn.dataset.productTitle;
    const image = addBtn.dataset.productImage;
    const url = addBtn.dataset.productUrl;

    let favorites = getFavorites();
    const exists = favorites.find(item => item.id === id);

    if (exists) {
      favorites = favorites.filter(item => item.id !== id);
    } else {
      favorites.push({ id, title, image, url });
    }

    saveFavorites(favorites);
    renderFavorites();
    syncFavoriteButtons();
    return;
  }

  /* ---------- REMOVE ---------- */
  const removeBtn = e.target.closest(".favorite-remove");
  if (removeBtn) {
    const id = removeBtn.dataset.id;

    let favorites = getFavorites();
    favorites = favorites.filter(item => item.id !== id);

    saveFavorites(favorites);
    renderFavorites();
    syncFavoriteButtons();
  }

});

/* -------------------------------
   初期化
-------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
  renderFavorites();
  syncFavoriteButtons();
});

/* -------------------------------
   カートドロワー再描画対策
-------------------------------- */
document.addEventListener("cart:refresh", () => {
  renderFavorites();
  syncFavoriteButtons();
});

document.addEventListener("drawer:open", () => {
  renderFavorites();
  syncFavoriteButtons();
});

/* 念のため */
setTimeout(() => {
  renderFavorites();
  syncFavoriteButtons();
}, 500);